<template>
  <div
    class="product-actions"
    :class="{
      'always-visible': isPlaceholderPage,
      'force-hover': showModal,
      centered: productActionsCentered,
    }"
  >
    <!-- Customize item button -->
    <div
      :class="{
        'product-action-circle':
          (isEditMode || isCreateMode || isPlaceholderPage) &&
          !isPlaybookDesignPage,
        'product-action-button btn':
          (isPreviewMode && !isPlaceholderPage) || isPlaybookDesignPage,
        'is-snapsheet': isSnapsheet,
        'is-playbook': isPlaybook,
      }"
      @click="
        goToActiveProductPage({
          ...product,
          designName: threekitDesignName,
          relatedPricesFromProject: product.related,
        })
      "
    >
      <img src="~@/assets/edit.svg" alt="Customize icon" />
      <span
        v-if="(isPreviewMode && !isPlaceholderPage) || isPlaybookDesignPage"
        >{{ customizeItemText }}</span
      >

      <!-- Placeholder page indicator -->
      <div v-if="isPlaceholderPage" class="edit-item-indicator left">
        Customize
      </div>
    </div>

    <!-- Swap, Move, Delete -->
    <template v-if="dealerMode && (isEditMode || isCreateMode) && isStockPage">
      <div class="product-action-circle" @click="openConfirmatioModal()">
        <img
          src="~@/assets/icons/ui/trash-outline-pink.svg"
          alt="Delete product"
        />
      </div>
      <div class="product-action-circle" @click="emitOpenSearchModal()">
        <img src="~@/assets/icons/ui/sync-outline.svg" alt="Swap product" />
      </div>

      <div
        class="move-buttons-container flex flex-column product-action-circle"
        v-if="!isUniqueProductInPage"
      >
        <button
          class="up"
          v-if="!productIsTheFirst"
          @click="
            swapProductOrders({
              catalog_page_order: product.catalog_page_order,
              catalog_page_index: product.catalog_page_index,
              action: 'up',
            })
          "
        >
          <img
            src="@/assets/icons/ui/up-arrow-circle-outline.svg"
            alt="up button"
          />
        </button>
        <button
          class="down"
          v-if="!productIsTheLast"
          @click="
            swapProductOrders({
              catalog_page_order: product.catalog_page_order,
              catalog_page_index: product.catalog_page_index,
              action: 'down',
            })
          "
        >
          <img
            src="@/assets/icons/ui/up-arrow-circle-outline.svg"
            alt="down button"
          />
        </button>
      </div>
    </template>

    <transition name="fade">
      <ModalAlert
        v-if="showModal"
        :text="`Are you sure you want to delete product '${product.name}'`"
        :title="'Removing Product '"
        :confirmationText="'Delete'"
        :cancelText="'Cancel'"
        :showButtons="true"
        @confirm="handleDeleteProduct()"
        @cancel="showModal = false"
        @closeModal="showModal = false"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ModalAlert from "@/components/Utils/ModalAlert";
export default {
  name: "ProductActions",

  props: {
    product: {
      type: Object,
      required: true,
    },
    productActionsCentered: {
      type: Boolean,
      default: false,
    },
    threekitDesignName: {
      type: String,
    },
    productStyleName: {
      type: String,
    },
    layout: {
      type: [Object, String],
      //required: true,
    },
    isPlaceholderPage: {
      type: Boolean,
    },
    isPlaybookDesignPage: {
      type: Boolean,
    },

    //playbook item props
    pageId: {
      type: Number,
    },
    pageType: {
      type: String,
    },
    layoutIndex: {
      type: Number,
    },
    columnIndex: {
      type: Number,
    },
    itemIndex: {
      type: Number,
    },
    itemsCount: {
      type: Number,
    },
    sportName: {
      type: String,
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    ...mapState("auth", ["dealerMode"]),
    ...mapState("dealer", ["rhino_code"]),
    ...mapState("project", ["typeOfProject"]),
    ...mapGetters("playbook", ["getPlaybookCards"]),
    ...mapGetters("project", [
      "isSnapsheet",
      "isPlaybook",
      "isCreateMode",
      "isEditMode",
      "isPreviewMode",
      "projectId",
    ]),
    ...mapGetters("threekit", ["isSublimated"]),

    ...mapState("snapsheet", {
      snapsheetProducts: (state) => state.products,
    }),

    customizeItemText() {
      return this.isSublimated(
        this.product?.style_id || this.product?.styleName
      )
        ? "Customize for free"
        : "Customize";
    },

    isStockPage() {
      return this.pageType === "stock";
    },

    isUniqueProductInPage() {
      return this.itemsCount === 1;
    },

    productIsTheFirst() {
      return this.itemIndex === 0;
    },

    productIsTheLast() {
      return this.itemIndex + 1 === this.itemsCount;
    },
  },

  methods: {
    ...mapActions("project", ["setActiveProduct", "goToActiveProductPage"]),
    ...mapActions("playbook", ["deletePlaybookItem", "swapProductOrders"]),

    async openConfirmatioModal() {
      this.showModal = true;
    },

    async handleDeleteProduct() {
      try {
        await this.deletePlaybookItem(this.product.id);
        this.showModal = false;
      } catch (error) {
        console.log(error);
      }
    },

    emitOpenSearchModal() {
      this.$emit("openSearchModal", this.product);
    },
  },

  components: { ModalAlert },
};
</script>

<style lang="scss">
.product-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  left: -1rem;
  top: 10%;
  visibility: hidden;
  z-index: 10;
  transition: all 0.2s;
  .product-action-circle,
  .product-action-button {
    visibility: hidden;

    &.btn {
      color: white;
      display: flex;
      align-items: center;
      padding: 0.3em 1em;
      span {
        color: white;
      }
      img {
        margin: 0 0.5em;
        margin-left: 0;
      }
    }

    &.move-buttons-container {
      border-radius: 50px;
      padding: 0.4rem 0;
      width: auto !important;
      height: auto !important;
      gap: 0.5rem;
      button {
        background: none;
        &.down {
          transform: rotate(180deg);
          &:hover {
            transform: rotate(180deg) scale(1.05) !important;
          }
        }
      }
    }

    &.is-snapsheet {
      margin-top: 50%;
      margin-left: 4rem;
    }
  }
  &.centered {
    top: 45%;
    left: 15%;
    width: 70%;
  }
  &.force-hover {
    visibility: visible;
  }
}

.product:hover,
.snap-card:hover {
  .product-actions:not(.always-visible) {
    visibility: visible;

    .product-action-circle,
    .product-action-button {
      visibility: visible;
      cursor: pointer;
      background: $dark;
      opacity: 0.7;
      transition: all 0.2s;

      &:hover {
        opacity: 1;
      }
    }

    .product-action-circle {
      height: 30px;
      width: 30px;
      border-radius: 58px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px 10px;
      &:hover {
        height: 40px;
        width: 40px;
        margin: 0px 5px;
      }
    }
  }
}

.always-visible.product-actions {
  visibility: visible !important;
  position: absolute;
  .product-action-circle {
    cursor: pointer;
    background: $dark;
    visibility: visible;
    height: 40px;
    width: 40px;
    border-radius: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px 10px;
  }
}

.product-container {
  .product-actions {
    left: initial;
    top: 40%;
  }
}
</style>
